import './Brands.css';
import flgr from "../../images/flgr.png";
import kl from "../../images/kl.gif";
import rlls from "../../images/rlls.png";
import rl from "../../images/rl.gif";

function Brands() {
  return (
    <div className="container-fluid brands">
      <div className="row align-items-center row-cols-1 row-cols-sm-2 row-cols-md-4">
        <div className="col text-center">
          <a href="http://www.flgr.ru/">
            <img className="brands__picture" src={flgr} alt="flgr sign"/>
          </a>
        </div>
        <div className="col text-center">
          <a href="http://rolski.ru/">
            <img className="brands__picture" src={kl} alt="kl sign"/>
          </a>
        </div>
        <div className="col text-center">
          <a href="http://www.rlls.ru/">
            <img className="brands__picture" src={rlls} alt="rlls sign"/>
          </a>
        </div>
        <div className="col text-center">
          <a href="https://russialoppet.ru/">
            <img className="brands__picture" src={rl} alt="rl sign"/>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Brands;